const toAbsoluteUrl = function(url) { return url && url.indexOf('http') !== 0 ? window.location.origin + url : url; };

export const pushKlaviyoEcommerce = data => {
    dataLayer.push({ klaviyoEcommerce: null });
    dataLayer.push(data);
};

export const klaviyoCheckout = (orderRows, eventId) => {
    const items = orderRows.map(row => { return { ...row.klaviyo, quantity: row.quantity }; });
    const itemNames = items.map(item => item.productName);
    const currentDomainUrl = window.location.protocol + '//' + window.location.host;
    const value = orderRows.reduce((p, v) => p + v.quantity * v.klaviyo.price, 0);
    const allCategories = orderRows.map(row => row.klaviyo.categories);
    const combinedCategories = allCategories.reduce((acc, val) => acc.concat(val), []);
    const uniqueCategories = [...new Set(combinedCategories)];
    const uniqueBrands = [...new Set(items.map(item => item.brand))];
    const timedEventId = eventId ? eventId + "_" + Date.now() : undefined;

    pushKlaviyoEcommerce({
        event: "klaviyoCheckout",
        klaviyoEcommerce: {
            "cartEventId": timedEventId,
            "cartValue": value,
            "itemNames": itemNames,
            "checkoutURL": currentDomainUrl + __litium.preloadState.cart.checkoutUrl,
            "categories": uniqueCategories,
            "brands": uniqueBrands,
            "items": items,
        }
    });
};

export const klaviyoAddToCart = (orderRows, product, quantity) => {
    const items = orderRows.map(row => { return { ...row.klaviyo, quantity: row.quantity }; });
    const itemNames = items.map(item => item.productName);
    const currentDomainUrl = window.location.protocol + '//' + window.location.host;
    const value = orderRows.reduce((p, v) => p + v.quantity * v.klaviyo.price, 0);

    pushKlaviyoEcommerce({
        event: "klaviyoAddToCart",
        klaviyoEcommerce: {
            "cartValue": value,
            "addedItemProductName": product.klaviyo.productName,
            "addedItemProductID": product.klaviyo.productID,
            "addedItemSKU": product.klaviyo.sku,
            "addedItemCategories": product.klaviyo.categories,
            "addedItemImageURL": product.klaviyo.imageURL,
            "addedItemURL": product.klaviyo.url,
            "addedItemPrice": product.klaviyo.price,
            "addedItemQuantity": quantity,
            "addedItemBrand": product.klaviyo.brand,
            "itemNames": itemNames,
            "checkoutURL": currentDomainUrl + __litium.preloadState.cart.checkoutUrl,
            "items": items,
        }
    });
};

export const klaviyoFavoritesAddProduct = (productId, productData = {}) => {
    pushKlaviyoEcommerce({
        event: 'FavoritesAddProduct',
        klaviyoEcommerce: { productId, ...productData, imageUrl: toAbsoluteUrl(productData.imageUrl), url: toAbsoluteUrl(productData.url) }
    });
};

export const klaviyoFavoritesRemoveProduct = (productId, productData = {}) => {
    pushKlaviyoEcommerce({
        event: 'FavoritesRemoveProduct',
        klaviyoEcommerce: { productId, ...productData, imageUrl: toAbsoluteUrl(productData.imageUrl), url: toAbsoluteUrl(productData.url) }
    });
};

export const klaviyoFavoritesAddToCart = ({ productId, sku, productName, brand, price, quantity }) => {
    pushKlaviyoEcommerce({
        event: 'FavoritesAddToCart',
        klaviyoEcommerce: { productId, sku, productName, brand, price, quantity }
    });
};

export const klaviyoFavoritesViewedFavorites = (items = []) => {
    const cappedItems = items.slice(0, 10).map(function(p) {
        return { productId: p.productId, productName: p.productName, brand: p.brand, price: p.price, imageUrl: toAbsoluteUrl(p.imageUrl), url: toAbsoluteUrl(p.url) };
    });
    pushKlaviyoEcommerce({
        event: 'FavoritesViewedFavorites',
        klaviyoEcommerce: { itemCount: items.length, items: cappedItems }
    });
};
